const NAV_LINKS = [
  { label: "Início", href: "#hero" },
  { label: "Sobre", href: "#sobre" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const LOGO_LIGHT =
  "https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/a59d050e-dd50-455f-9ad9-f9d3b2575f8f_m-clara.png?v=4526a1b287edd10cb53e6317eeac57fd";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full" style={{ backgroundColor: "rgb(40, 18, 14)" }}>
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-5">
            <div className="flex items-center justify-start">
              <img
                src={LOGO_LIGHT}
                alt="Martins Advocacia"
                style={{ height: "72px", width: "auto" }}
                className="object-contain"
              />
            </div>
            <p className="font-body text-sm text-white/50 leading-relaxed">
              Defendendo seus direitos previdenciários com atenção, estratégia e
              cuidado. Atendimento humanizado em todo o Brasil.
            </p>
            <div className="flex items-center gap-3 mt-1">
              <a
                href="https://wa.me/5581995913182"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-md border border-white/15 text-peach hover:border-peach/50 transition-colors duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
              <a
                href="mailto:martins.adv.suellen@gmail.com"
                className="w-9 h-9 flex items-center justify-center rounded-md border border-white/15 text-peach hover:border-peach/50 transition-colors duration-300 cursor-pointer"
                aria-label="E-mail"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-sm font-semibold text-white/80 mb-5 uppercase tracking-wider">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#hero");
                }}
              >
                Links Rápidos
              </a>
            </h4>
            <ul className="flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="font-body text-sm text-white/45 hover:text-peach transition-colors duration-200 cursor-pointer flex items-center gap-2"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-xs" />
                    </div>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold text-white/80 mb-5 uppercase tracking-wider">
              Contato
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-whatsapp-line text-base text-peach" />
                </div>
                <div>
                  <a
                    href="https://wa.me/5581995913182"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-body text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    (81) 99591-3182
                  </a>
                  <p className="font-body text-xs text-white/30 mt-0.5">
                    WhatsApp / Telefone
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-base text-peach" />
                </div>
                <div>
                  <a
                    href="mailto:martins.adv.suellen@gmail.com"
                    className="font-body text-sm text-white/60 hover:text-white transition-colors cursor-pointer break-all"
                  >
                    martins.adv.suellen@gmail.com
                  </a>
                  <p className="font-body text-xs text-white/30 mt-0.5">
                    E-mail profissional
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-base text-peach" />
                </div>
                <div>
                  <p className="font-body text-sm text-white/60">Recife – PE</p>
                  <p className="font-body text-xs text-white/30 mt-0.5">
                    Atendimento em todo o Brasil
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/30 text-center md:text-left">
            © {year} Martins Advocacia – Dra. Suellen Martins. Todos os direitos
            reservados.
          </p>
          <p className="font-body text-xs text-white/30 text-center">
            Desenvolvido por{" "}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-peach/70 hover:text-peach transition-colors cursor-pointer"
            >
              Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
